export interface トークン型 {
    アクセストークン: string;
    リフレッシュトークン: string;
}

export interface 認証型 {
    医療機関コード: string;
    利用者コード: string;
    パスワード: string;
}

export class 代行ログイントークン型 {
    public 代行ログイントークン: string;

    constructor(代行ログインURL: string) {
        const agencyToken = 代行ログインURL.substr(代行ログインURL.lastIndexOf('/') + 1);
        this.代行ログイントークン = agencyToken;
    }
}
